<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    레귤러 콘텐츠관리
                    <div class="clear"></div>
                </div>
                <div class="refund_caption">
                    콘텐츠들은 APP에서 이름 오름차순으로 우선노출 합니다.
                </div>
                <div class="list-content">
                    <content-list-component :contentType="'regular'" :defaultLang="30"></content-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

        </div>
    </div>
</template>

<script>
import ContentListComponent from "@/components/content/ContentListComponent";
export default {
    name: 'RegularContent',
    mixins: [],
    components: {ContentListComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>
